import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { BrgButton, ButtonVariant } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '@brg/auth';
import { IconCloseMob } from 'shared/modals/SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {
  CloseButton,
  FoldersColumnContainer,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalFilledButton,
  ModalHeaderRow,
  ModalHollowButton,
  ModalTitle,
} from './styles';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionAdminActions, CompetitionAdminSelector } from 'shared/reducers/CompetitionAdminSlice';
import { useGetCompetitionNavigateTabs } from 'shared/components/navigationSystem/useGetCompetitionNavigateTabs';
import { BEST_FOLDER } from 'shared/components/navigationSystem/const/const';
import { FolderT } from 'shared/pages/designer/components/tabs/const';

type MoveCompetitionsModalProps = {
//   mode: 'join' | 'change';
//   targetTeamId: string;
//   targetTeamName: string;
//   currentClubName?: string;
competitionIds: string[],
onConfirm: (folderId: string, competitionsIds: string[]) => void
};

export const MoveCompetitionsModal: FC<MoveCompetitionsModalProps> = ({
//   mode,
//   targetTeamId,
//   targetTeamName,
//   currentClubName,
competitionIds,
onConfirm
}) => {
  const { t } = useTranslation();
  const modal = useModal();
  const dispatch = useDispatch();
  const profile = useProfile();
  const [isLoading, setIsLoading] = useState(false);
  const [{ tab: currentFolderId }, setQueryParams] = useQueryState();
  const [selectedFolder, setSelectedFolder] = useState<string | null>(null);

  const isCurrentFolderSelected = useMemo(() => {
    return currentFolderId === selectedFolder 
  }, [selectedFolder, currentFolderId]);

  const onFolderClick = useCallback((id: any) => {
    setSelectedFolder(id);
  }, []);

  useEffect(() => {
    if (!selectedFolder) {
      setSelectedFolder(currentFolderId);
    }
  } , [selectedFolder, currentFolderId])

  const folders = useGetCompetitionNavigateTabs({ 
        type: 'admin', 
        disableDefaultFolder: true, 
        disableFolderIcons: true,
        disableFolderActions: true, 
        onFolderClick,
        selectedId: selectedFolder ?? ''
    });

  const foldersComponents = useMemo(() => {
    return folders.map((tab) => {
      if (tab?.key === BEST_FOLDER.id) {
        return null;
      }
        return (
            <div key={tab?.key} onClick={() => {setSelectedFolder(tab?.key ?? null)}}>
                {tab?.component}
            </div>
        )
    })
  }, [folders]);

    const handleClose = useCallback(() => {
        modal.hide();
    }, [modal]);

  const handleConfirm = () => {
    if (!selectedFolder) {
      return;
    }
    onConfirm(selectedFolder, competitionIds);
    handleClose();
  };

  const title = isCurrentFolderSelected 
    ? 'Добавить в папку'
    : 'Добавить в папку'


  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{'Выберите папку'}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <FoldersColumnContainer >
        {foldersComponents}
      </FoldersColumnContainer>
      <ModalActions>
      <ModalHollowButton
          variant={ButtonVariant.Hollow}
          fullWidth
          onClick={handleClose}
        >
          {'Отмена'}
        </ModalHollowButton>
        <ModalFilledButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {title}
        </ModalFilledButton>
      </ModalActions>
    </ModalBody>
  );
};

export default MoveCompetitionsModal;
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { BrgButton, ButtonVariant } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '@brg/auth';
import { IconCloseMob } from 'shared/modals/SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {
  CloseButton,
  FoldersColumnContainer,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalFilledButton,
  ModalHeaderRow,
  ModalHollowButton,
  ModalTitle,
} from './styles';
import useQueryState from 'shared/hooks/useQueryState';
import { CompetitionAdminActions, CompetitionAdminSelector } from 'shared/reducers/CompetitionAdminSlice';
import { useGetCompetitionNavigateTabs } from 'shared/components/navigationSystem/useGetCompetitionNavigateTabs';
import { BEST_FOLDER } from 'shared/components/navigationSystem/const/const';
import { FolderT } from 'shared/pages/designer/components/tabs/const';

type MoveCompetitionsModalProps = {
//   mode: 'join' | 'change';
//   targetTeamId: string;
//   targetTeamName: string;
//   currentClubName?: string;
competitionIds: string[],
onConfirm: (folderId: string, competitionsIds: string[]) => void
};

export const MoveCompetitionsModal: FC<MoveCompetitionsModalProps> = ({
//   mode,
//   targetTeamId,
//   targetTeamName,
//   currentClubName,
competitionIds,
onConfirm
}) => {
  const { t } = useTranslation();
  const modal = useModal();
  const dispatch = useDispatch();
  const profile = useProfile();
  const [isLoading, setIsLoading] = useState(false);
  const [{ tab: currentFolderId }, setQueryParams] = useQueryState();
  const [selectedFolder, setSelectedFolder] = useState<string | null>(null);

  const isCurrentFolderSelected = useMemo(() => {
    return currentFolderId === selectedFolder 
  }, [selectedFolder, currentFolderId]);

  const onFolderClick = useCallback((id: any) => {
    setSelectedFolder(id);
  }, []);

  useEffect(() => {
    if (!selectedFolder) {
      setSelectedFolder(currentFolderId);
    }
  } , [selectedFolder, currentFolderId])

  const folders = useGetCompetitionNavigateTabs({ 
        type: 'admin', 
        disableDefaultFolder: true, 
        disableFolderIcons: true,
        disableFolderActions: true, 
        onFolderClick,
        selectedId: selectedFolder ?? ''
    });

  const foldersComponents = useMemo(() => {
    return folders.map((tab) => {
      if (tab?.key === BEST_FOLDER.id) {
        return null;
      }
        return (
            <div key={tab?.key} onClick={() => {setSelectedFolder(tab?.key ?? null)}}>
                {tab?.component}
            </div>
        )
    })
  }, [folders]);

    const handleClose = useCallback(() => {
        modal.hide();
    }, [modal]);

  const handleConfirm = () => {
    if (!selectedFolder) {
      return;
    }
    onConfirm(selectedFolder, competitionIds);
    handleClose();
  };

  const title = isCurrentFolderSelected 
    ? 'Добавить в папку'
    : 'Добавить в папку'


  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{'Выберите папку'}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <FoldersColumnContainer >
        {foldersComponents}
      </FoldersColumnContainer>
      <ModalActions>
      <ModalHollowButton
          variant={ButtonVariant.Hollow}
          fullWidth
          onClick={handleClose}
        >
          {'Отмена'}
        </ModalHollowButton>
        <ModalFilledButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {title}
        </ModalFilledButton>
      </ModalActions>
    </ModalBody>
  );
};

export default MoveCompetitionsModal;
